import React, { Component } from 'react';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import { Row, Col, FormControl, Button,Table, Pagination} from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { addDays } from 'date-fns';
import DoubleScreen from './DoubleScreen';
import moment from "moment";
export default class SearchFile extends Component {
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      searchClicked:false,
      activePage:1
    }
    this.bulkclientName=[]
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName=[];
    if(!_.isEmpty(selectedcenterName)){
    _.map(selectedcenterName, (obj)=>{
        let x = _.filter(obj.userClients);
        clientName.push(...x );
        this.bulkclientName=clientName
    }) 
    return _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
      _.map(selectedclientName, (obj)=>{
          let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
          _.map(abc, (z) => {
            processName.push(...z.userProcesses)
            processName = _.uniqBy(processName, 'inventoryProcessId');
          })
      })    
    }
    return processName;
  }
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[]})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
  }
  handleChangeStart = (date) => {
    //date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
    this.setState({startDate: date});
    if(!_.isEqual(this.state.startDate, date)){
      this.setState({endDate:''})
    }
  }
  handleChangeEnd = (e) => {
   // e.setMinutes( e.getMinutes() + e.getTimezoneOffset() );
    this.setState({endDate: e});
  }
  validateForm() {  
    if((typeof this.state.startDate !== 'undefined')  && (typeof this.state.endDate !== 'undefined'))
      return true;
  }
  handleMobile = (e) =>{
    this.setState({mobileNo:e.target.value})
  }
  handleSearch = () =>{
    this.props.action.TokenValidation()    
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate, endDate, mobileNo} = this.state;
    this.setState({searchClicked:true})
    let obj ={
      'region': selectedregionName.inventoryRegionId.toString(),
      'center': _.map(selectedcenterName, (x) =>{return x.inventoryCenterId}),
      'client': _.map(selectedclientName, (x) =>{return x.inventoryClientId}),
      'process': _.map(selectedprocessName, (x) =>{return x.inventoryProcessId}),
      'mobileNo':mobileNo,
      'startDate':moment(startDate).format('YYYY-MM-DD'),
      'endDate':moment(endDate).format('YYYY-MM-DD'),
    }
    this.props.action.SearchWorkItemRecords(obj)
  }
  resetTemplate = () =>{
    this.setState({
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      startDate:null,
      searchClicked:false,
      endDate:null,
      activePage:1
    })
  }
  handleDoubleClick = (i, id, status) => {
    if(status === 'Completed'){
     this.setState({['showDouble'+i]:true})
     this.props.action.TokenValidation()  
     this.props.action.auditorScoreCalculation(id)
    }
  }
  onClose = (i) => {
    this.setState({['showDouble'+i]:false})
  }
  renderInboxValues = (data, startOffset, startCount, Per_Page) => {  
    let returnObj;
    if(!_.isEmpty(data)){   
      returnObj = _.map(data, (obj, index) =>{
        if(index >= startOffset & startCount < Per_Page){
          startCount++;
      let templatevalue;  
      if(!_.isNull(obj.auditFormWithoutFeedback)){
        templatevalue = obj.auditFormWithoutFeedback
      } else {
        templatevalue = obj.auditFormWithFeedback;
      }
       return(
       <tr  onDoubleClick={()=>this.handleDoubleClick(index, obj.id, obj.status)}>
         {this.state['showDouble'+index] ? <DoubleScreen closeModal={()=>this.onClose(index)} object={obj}
         auditorJSON={templatevalue} loginUserName={this.props.loginUserName} ScoreCalculation={this.props.ScoreCalculation}
         action={this.props.action} 
           /> 
         : null}
         <td>{obj.id}</td>           
         <td>{obj.callDate}</td>   
         <td>{obj.updated_date}</td> 
         <td>{obj.agentName}</td>
         <td>{obj.auditorName}</td>
         <td>{obj.msisdn}</td>  
         <td>{obj.regionName}</td>
         <td>{obj.centerName}</td>  
       <td>{obj.clientName}</td>         
         <td>{obj.processName}</td>      
         <td>{obj.status}</td>     
         <td>{obj.overallAttributeScore}</td> 
       </tr>)                     
     
       }
      })
    } else {
      returnObj = (<tr><td colSpan="12">No Records Found</td></tr>)
    }
    return returnObj;
  }
  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
  }
  handleSelectPaginationPrev = () => {
    const {activePage} = this.state;
    this.setState({
      activePage: activePage-1,
    });
  }
  handleSelectPaginationNext = () => {
    const {activePage} = this.state;
    this.setState({
      activePage: activePage+1,
    });
  }
  render(){
    const{searchClicked, activePage} = this.state;
    const Per_Page=50;  
    let totalPages = 1
    if(!_.isEmpty(this.props.searchRecord)){
      totalPages = Math.ceil(this.props.searchRecord.length/Per_Page)
    }
    let items = []; 
    const startOffset = (this.state.activePage-1) * Per_Page;
    let startCount = 0;
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
          {number}
        </Pagination.Item>				
      );
    }
    return(
    <div>
      <Row>
      <Col>
        <label>Region Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedregionName}
        options={this.regionNames()}
        onChange={this.handleSelect}
        open={false}
        valueKey="inventoryRegionName"
        labelKey="inventoryRegionName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Region'
        dropdownHeight={600}
      />
      </Col>
    </Row> 
      <Row>
      <Col>
        <label>Center Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedcenterName}
        options={this.centerNames()}
        onChange={this.handleSelectCenter}
        open={false}
        valueKey="inventoryCenterName"
        labelKey="inventoryCenterName"
        multiple={true}
        includeSelectAll={true}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Center'
        dropdownHeight={600}
      />
      </Col>             
    </Row>
      <Row>
      <Col>
        <label>Client Name</label>
      </Col>
      <Col>
    <Picky keepOpen={false}
      value={this.state.selectedclientName}
      options={this.clientNames()}
      onChange={this.handleSelectClient}
      open={false}
      valueKey="inventoryClientName"
      labelKey="inventoryClientName"
      multiple={true}
      includeSelectAll={true}
      includeFilter={true}
      clearFilterOnClose={true}
      placeholder='Select Client'
      dropdownHeight={600}
    />
    </Col>
    </Row> 
      <Row>
      <Col>
      <label>Process Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
      value={this.state.selectedprocessName}
      options={this.processNames()}
      onChange={this.handleSelectProcess}
      open={false}
      valueKey="inventoryProcessName"
      labelKey="inventoryProcessName"
      multiple={true}
      includeSelectAll={true}
      includeFilter={true}
      clearFilterOnClose={true}
      placeholder='Select Process Name'
      dropdownHeight={600}
    />
     </Col>
     </Row> 
      <Row>
      <Col>
      <label>Mobile Number</label>
      </Col>
      <Col>
      <FormControl type='number' placeholder="Mobile Number" onChange={this.handleMobile}/>
     </Col>
      </Row>
      <Row>
        <Col>
        <label>Date Range<span className='RedColoring'>*</span></label>
       </Col>
        <Col className='myContainter'>
        <DatePicker
           selected={this.state.startDate}
           className='myDatePicker'
           selectsStart
           showMonthDropdown
           startDate={this.state.startDate}
           endDate={this.state.endDate}
           onChange={this.handleChangeStart}
           placeholderText="Select a date Range"
           maxDate={addDays(this.state.startDate, 14)}
          />
        <DatePicker
          selected={this.state.endDate}
          selectsEnd
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.handleChangeEnd}
          minDate={this.state.startDate}
          placeholderText="Select a date Range"
          maxDate={addDays(this.state.startDate, 14)}
          />    
       </Col> 
     </Row>
     <br/> 
     <center><Button className='buttonwidth' disabled={!this.validateForm()} onClick={this.handleSearch}>Search</Button>
     &nbsp;<Button onClick={this.resetTemplate} className='buttonwidth'>Reset</Button>
     </center>
     <br/>
     {((searchClicked)) ?  
        <p className='calibration'>
        <Table responsive>
          <thead>
            <th>TRANSACTION NO</th>              
            <th>CALL DATE</th> 
            <th>AUDITED DATE</th> 
            <th>AGENT NAME</th>  
            <th>AUDITOR NAME</th>
            <th>MOBILE NO</th>  
            <th>REGION</th>
            <th>CENTER</th>
            <th>CLIENT</th>
            <th>PROCESS</th>
            <th>STATUS</th>
            <th>OVERALL SCORE</th>
          </thead>
          <tbody>
            { this.renderInboxValues(_.cloneDeep(this.props.searchRecord), startOffset, startCount, Per_Page)}    
          </tbody>
        </Table>
        <Pagination>
          <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
          <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
          {items[activePage-1]}
          {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
          {items[activePage+1]}
          <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
          <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
      </Pagination>        
       </p>: null} 
    </div>)
  }
}